
import { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Typography } from '@mui/material';
import { Calendar } from 'primereact/calendar';
import { AutoComplete } from 'primereact/autocomplete';
import { Menu, MenuMenu } from 'semantic-ui-react';
import { connect } from 'react-redux';
import Button from '@mui/material/Button';
import "primereact/resources/themes/lara-light-indigo/theme.css";

import classes from './classes.module.scss';

import {
    getAccounts
} from 'app/services/accounts';

import {
    getDailyReadReport
} from 'app/services/reports'

import {
    formatOptions
} from 'app/utils/options';

import {
    formatCurrency
} from 'app/utils/valueFormatters';

const DailyReadReport = (props) => {
    const { account } = props;
    const [loaded, setLoaded] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [filteredAccounts, setFilteredAccounts] = useState([]);
    const [details, setDetails] = useState([]);
    const [summary, setSummary] = useState([]);

    useEffect(() => {
        if (!loaded) {
            let accountId = account.id;
            if (selectedAccount && accountId === -1) {
                accountId = selectedAccount.value;
            }

            if (startDate && endDate) {
                getDailyReadReport({ account_id: accountId, start_date: startDate, end_date: endDate }).then((result) => {
                    setDetails(result.daily_read_detailed);
                    if (result.daily_read_summary) {
                        setSummary([result.daily_read_summary]);
                    }
                }).catch((resp) => {
                    console.log(resp);
                })
            }
            setLoaded(true);
        }
    }, [loaded])

    const getAccountOptions = async (page = 1, perPage = 100, filter = null) => {
        let params = {
            page,
            per_page: perPage
        }

        if (filter) {
            params.filter_model = {
                name: [{
                    filterClass: 'text',
                    filterType: 'contains',
                    value: filter
                }]
            }
        }

        let resp = await getAccounts(params);
        return formatOptions(resp.records);
    }

    const searchAccounts = (e) => {
        const selected = e.query;

        if (!selected) {
            getAccountOptions().then(recs => {
                setFilteredAccounts(recs);
            });
        }

        if (selected) {
            getAccountOptions(1, 100, selected).then(recs => {
                setFilteredAccounts(recs);
            });
        }
    }

    const handleDateChanged = (dateType, dateValue) => {
        if (dateType === 'start_date') {
            setStartDate(dateValue);
        } else {
            setEndDate(dateValue);
        }
        setLoaded(false);
    }

    const currencyBodyTemplate = (rowData, column) => {
        return <label>{formatCurrency(rowData[column.field], rowData.currency)}</label>
    }

    let sx = { margin: '0 0.5rem' };

    const header = (
        <div>
            <div className={classes.toolbar}>
                <Menu stackable secondary fluid>
                    <Menu.Item>
                        <Typography variant="h1">
                            Daily Read Report
                        </Typography>
                    </Menu.Item>

                    <MenuMenu position='right'>
                        {
                            account.id === -1 && <Menu.Item>
                                <AutoComplete
                                    value={selectedAccount}
                                    field="label"
                                    suggestions={filteredAccounts}
                                    completeMethod={searchAccounts}
                                    onChange={(e) => {
                                        setSelectedAccount(e.value);
                                        setLoaded(false);
                                    }}
                                    placeholder={'Select Account'}
                                    dropdown
                                />
                            </Menu.Item>
                        }

                        <Menu.Item>
                            <Calendar id="start_date" placeholder='Start Date' value={startDate} onChange={(e) => handleDateChanged('start_date', e.value)} showIcon />
                        </Menu.Item>
                        <Menu.Item>
                            <Calendar id="end_date" placeholder='End Date' value={endDate} onChange={(e) => handleDateChanged('end_date', e.value)} showIcon />
                        </Menu.Item>
                        <Menu.Item>
                            <Button sx={sx} variant='contained' onClick={() => exportCSV(false)} data-pr-tooltip="CSV">Export CSV</Button>
                        </Menu.Item>
                    </MenuMenu>
                </Menu>
            </div>
        </div>
    );

    return <div>
        {header}
        <DataTable value={summary} className={classes.datatable}>
            <Column field='photo_count' header="Photo Count" />
            <Column field='group_count' header="Scanned Groups" />
            <Column field='login_count' header="Scanned Groups at Kiosk" />
            <Column field='transactions' header="Transactions" />
            <Column field='transaction_total' header="Sales Dollars" body={currencyBodyTemplate} />
            <Column field='transaction_quantity' header="Photos Sold" />
            <Column field='transaction_aov' header="AOV" body={currencyBodyTemplate} />
        </DataTable>
        <br />
        <DataTable value={details} className={classes.datatable} scrollable scrollHeight="400px">
            <Column field='user' header="User" />
            <Column field='photo_count' header="Photo Count" />
            <Column field='group_count' header="Scanned Groups" />
            <Column field='purchased_photo_count' header="Purchased Photo Count" />
            <Column field='transactions' header="Transactions" />
            <Column field='transaction_total' header="Sales Dollars" body={currencyBodyTemplate} />
            <Column field='transaction_quantity' header="Photos Sold" />
            <Column field='transaction_aov' header="AOV" body={currencyBodyTemplate} />
        </DataTable>
    </div>
}

const mapStateToProps = state => ({
    account: state.portalReducer.account
});

export default connect(mapStateToProps, {})(DailyReadReport);